import ContextualMenu from './ContextualMenu';

export default ContextualMenu;
